import React from "react";
import FundRulesTable from "../../features/icfundrulestable";

const HouseRulesFundRulesPage = () => <FundRulesTable />

export default HouseRulesFundRulesPage;